import styles from './fade.module.scss';
import MaterialFade from '@mui/material/Fade';

/* eslint-disable-next-line */
export interface FadeProps {
  children: any,
  // addEndListener?: any,
  // appear?: boolean,
  // easing?: { enter?: string, exit?: string } | string,
  in?: boolean,
  // timeout?: number | { appear?: number, enter?: number, exit?: number }
}

export function Fade(props: FadeProps) {
  return (
    <MaterialFade
      in={props.in}>
      {props.children}
    </MaterialFade>
  );
}

export default Fade;